{
  "page": {
    "title": "Revenue",
    "description": "What SIB earned across the book: the savings share and the fees together"
  },
  "periods": {
    "label": "Revenue period",
    "allTime": "All time",
    "thisMonth": "This month",
    "thisQuarter": "This quarter",
    "thisYear": "This year",
    "selectRange": "Select range"
  },
  "toggles": {
    "label": "Revenue filters",
    "billingsWithoutContract": "+ Billings without a contract",
    "allIdentifiedSavings": "+ All identified savings",
    "projectedRevenue": "+ Projected revenue"
  },
  "summary": {
    "total": "Total",
    "savingsShare": "Savings share",
    "fees": "Fees"
  },
  "view": {
    "label": "Revenue display",
    "spendCategory": "Display by spend category & service",
    "organization": "Display by organization",
    "organizationPlaceholder": "Organization view is not available yet."
  },
  "table": {
    "expandRow": "Expand row",
    "collapseRow": "Collapse row",
    "columns": {
      "spendCategory": "Spend category / service",
      "type": "Type",
      "billings": "Billings",
      "expected": "Expected",
      "earned": "Earned",
      "internal": "Internal"
    },
    "type": {
      "savingsShare": "Savings share"
    },
    "noData": {
      "title": "No revenue rows",
      "description": "No revenue rows match the current filters."
    }
  }
}
